module.exports = __webpack_public_path__ + "img/jobShareLogo.354e707c.png";